import { render, staticRenderFns } from "./ExcelPresupuestoEjercicio.vue?vue&type=template&id=533a6630&"
import script from "./ExcelPresupuestoEjercicio.vue?vue&type=script&lang=js&"
export * from "./ExcelPresupuestoEjercicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports